export const integrationChips = [
  { label: 'WhatsApp', fill: '#25D366', svg: 'whatsapp' },
  { label: 'Facebook Messenger', fill: '#1877F2', svg: 'messenger' },
  { label: 'Email / Gmail', fill: '#0078D4', svg: 'email' },
  { label: 'WordPress / Web', fill: '#21759B', svg: 'wordpress' },
];

export const painPoints = [
  {
    icon: '🔁',
    title: 'Preguntas repetitivas todo el día',
    description:
      'Precios, horarios, envíos, disponibilidad… las mismas 10 preguntas, decenas de veces al día.',
  },
  {
    icon: '⏰',
    title: 'No puedes atender 24/7',
    description:
      'Tus clientes escriben de noche, en fines de semana y tú no siempre puedes responder a tiempo.',
  },
  {
    icon: '📧',
    title: 'Bandeja de entrada desbordada',
    description:
      'Correos sin leer, mensajes sin responder. El seguimiento se pierde y los clientes se van.',
  },
  {
    icon: '💸',
    title: 'No tienes presupuesto para TI',
    description:
      'No cuentas con un equipo técnico, pero sabes que la tecnología puede ayudarte a crecer.',
  },
];

export const services = [
  {
    icon: '💬',
    title: 'Chatbots y asistentes virtuales',
    description:
      'Tu asistente inteligente disponible 24/7 en los canales donde están tus clientes, respondiendo al instante sin intervención humana.',
    tags: ['WhatsApp', 'Facebook Messenger', 'Chat web', 'FAQs automáticas'],
  },
  {
    icon: '⚡',
    title: 'Automatización de respuestas',
    description:
      'Ideal para negocios con alto volumen de consultas repetitivas. Clasificamos, priorizamos y respondemos mensajes de chat y email de forma automática.',
    tags: ['Email', 'Chat', 'Alto volumen', 'Seguimiento'],
  },
  {
    icon: '🎯',
    title: 'Clasificación de tickets',
    description:
      'Cada solicitud va al lugar correcto automáticamente. Prioridad alta, queja, consulta, ventas — la IA lo detecta y lo enruta sin errores humanos.',
    tags: ['Soporte técnico', 'Ventas', 'Enrutamiento'],
  },
  {
    icon: '✍️',
    title: 'Generación de contenido automático',
    description:
      'Posts para redes sociales, artículos de blog para WordPress y textos optimizados para SEO, creados con IA entrenada en tu giro de negocio.',
    tags: ['Redes sociales', 'WordPress', 'SEO', 'Blog'],
  },
  {
    icon: '📊',
    title: 'Análisis de datos simples',
    description:
      'Convierte tus ventas, consultas y métricas en insights accionables. Reportes claros que te dicen exactamente qué está pasando y qué hacer.',
    tags: ['Ventas', 'Tendencias', 'Dashboards'],
  },
  {
    icon: '🤖',
    title: 'Automatización de tareas internas',
    description:
      'Desde generar reportes, enviar recordatorios, actualizar hojas de cálculo hasta procesar documentos — liberamos tiempo de tu equipo para lo que realmente importa.',
    tags: ['Reportes', 'Recordatorios', 'Flujos internos'],
  },
];

export const steps = [
  {
    num: '01',
    title: 'Diagnóstico gratuito',
    description:
      'Analizamos tu negocio, identificamos dónde pierdes más tiempo y qué procesos se pueden automatizar de inmediato.',
  },
  {
    num: '02',
    title: 'Propuesta a medida',
    description:
      'Te entregamos una propuesta concreta con inversión, tiempo de implementación y ROI esperado. Sin letra chica.',
  },
  {
    num: '03',
    title: 'Implementación rápida',
    description:
      'Configuramos todo. Conectamos las herramientas con tu operación actual. Tu equipo no necesita saber programar.',
  },
  {
    num: '04',
    title: 'Soporte y mejora continua',
    description:
      'Te acompañamos, medimos resultados y ajustamos para que la automatización mejore con el tiempo.',
  },
];

export const testimonials = [
  {
    initials: 'CR',
    avatarClass: 'av-1',
    author: 'Carmen Ríos',
    business: 'Distribuidora textil, CDMX',
    quote:
      'Antes respondíamos más de 200 mensajes diarios manualmente. Ahora el chatbot resuelve el 90% solo. Mi equipo por fin puede enfocarse en cerrar ventas.',
  },
  {
    initials: 'JM',
    avatarClass: 'av-2',
    author: 'Jorge Mendoza',
    business: 'Ferretería industrial, Monterrey',
    quote:
      'Implementaron el sistema de clasificación de tickets en 2 semanas. Ahora no se nos pierde ninguna queja y el tiempo de resolución bajó a la mitad.',
  },
  {
    initials: 'AL',
    avatarClass: 'av-3',
    author: 'Andrea López',
    business: 'E-commerce de moda, Guadalajara',
    quote:
      'Lo que más me gustó es que no necesité contratar a nadie de sistemas. Ellos configuraron todo y ahora genero contenido para mis redes en automático.',
  },
];
